import { Ticket } from "callable-data-objects";
import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import EventsView from "Components/Events/EventsView";
import { useAccount } from "Hooks/Endpoints";
import APIEventsProvider from "Providers/APIEventsProvider";
import React, { useEffect } from "react";

type TicketAccountEventsType = {
  ticket: Ticket;
  accountRef: DBReference;
};
const TicketAccountEvents = ({
  ticket,
  accountRef,
}: TicketAccountEventsType) => {
  const { account, select } = useAccount();
  useEffect(() => {
    select(accountRef.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!account) return <span />;

  return (
    <APIEventsProvider>
      <EventsView />
    </APIEventsProvider>
  );
};

export default TicketAccountEvents;
